module.exports = __webpack_public_path__ + "front/img/p1.0a28841e.jpg";